import { render, staticRenderFns } from "./seafirmsmenu.vue?vue&type=template&id=0267b712&scoped=true&"
import script from "./seafirmsmenu.vue?vue&type=script&lang=js&"
export * from "./seafirmsmenu.vue?vue&type=script&lang=js&"
import style0 from "./seafirmsmenu.vue?vue&type=style&index=0&id=0267b712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0267b712",
  null
  
)

export default component.exports